import React, { useEffect, useState } from "react"
import {
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Modal,
  Button,
  useAccordionButton,
} from "react-bootstrap"
import TableCommponnent from "../../components/TableCommponnent"
import PageTitleBar from "../../components/PageTitleBar"
import { ReactComponent as ThumbsUp } from "../../assets/images/thumbsup.svg"
import { ReactComponent as ThumbsDown } from "../../assets/images/thumbsdown.svg"
import { ReactComponent as ApprovalModalImage } from "../../assets/images/image 12.svg"
import ApprovalStatusImage from "../../assets/images/image 12.png"
import { NumericFormat } from "react-number-format"
import { format } from "date-fns"
import formatText from "../../components/formatText"
import axiosInstance from "../../services/axiosInstance"
import Header from "../apprLyout/Topnav"
import Loader from "../../components/Loader"
import Sidenav from "../apprLyout/Sidenav"
import { useNavigate, useLocation } from "react-router-dom"
import Invoice from "../../components/Invoice"
import Error from "../../components/Error"
import SessionExpired from "./sessionExpired"
import { Info } from "lucide-react"
import { buildRouteQuery } from "../../utils/queryParams"

const ApprovalPage = () => {
  const navigate = useNavigate()
  const invoice = JSON.parse(localStorage.getItem("invoice"))
  const approvalCommentRequired = invoice?.workflow?.pending_approval_from === "accounts_payable"
  const roles = JSON.parse(localStorage.getItem("roles")) || []
  const isAccountsPayable = roles.includes("accounts_payable")
  const [selectedIds, setSelectedIds] = useState([])
  const [bulkAction, setBulkAction] = useState(false)
  const [invoiceData, setInvoiceData] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [sessionExpired, setsessionExpired] = useState(false)
  const [showMessage, setShowMessage] = useState(false)
  const [loading, setLoading] = useState(false)
  const Colour = "#3513f1"
  const vendor_Signature = "Vendor Signature"
  const [error, setError] = useState(null)
  const location = useLocation()
  const token = localStorage.getItem("accessToken")
  const name = localStorage.getItem("name")
  const totalPages = Math.ceil(invoiceData?.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentData = invoiceData?.slice(startIndex, endIndex)
  const [activeItemId, setActiveItemId] = useState(null)
  const [comment, setComment] = useState("")
  const [sign, setSign] = useState(null)
  const [hoveredAction, setHoveredAction] = useState(null)
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)
  const [total, setTotal] = useState(1)
  const [count, setCount] = useState(1)
  const [modalState, setModalState] = useState(false)
  const [approvalMessage, setApprovalMessage] = useState("")
  const [confirmationModalShow, setConfirmationModalShow] = useState(false)
  const [action, setAction] = useState(null)
  // const Invoice = localStorage.getItem('responseData') !=='undefined' ?JSON.parse(localStorage.getItem('responseData')) :[];
  // const {Invoice}=TableData
  // const navigate = useNavigate();
  // const Colour = vendordetails?.vendor_settings?.invoice_color ?? '#027C94';

  const getSignables = async (page, size) => {
    setLoading(true)

    try {
      const roles = JSON.parse(localStorage.getItem("roles")) || []
      const isAdmin = roles.includes("dmd_ss")
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/approvals/v1/${isAdmin ? "any" : "get"}/invoice/pending?page=${page}&size=${size}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      console.log(response.data.data, "I am the res")
      localStorage.setItem("responseData", JSON.stringify(response.data.data))
      setInvoiceData(response.data.data.results)
      setCount(response.data.data.count)
      const totalPages = Math.ceil(response.data.data.count / size)
      setTotal(totalPages)
    } catch (error) {
      console.log(error, "PO fetching error.")
      const errorMessage =
        error?.response?.data?.detail || "Error Fetching PO Items"
          ? error?.response?.data?.detail
          : "Error Fetching PO"

      if (error?.response?.status === 401) {
        // Call handleLogout in case of 401 error
        // handleLogout(msalConfig, userName, navigate);
        setsessionExpired(true)
      } else {
        setError(errorMessage)
      }
    } finally {
      setLoading(false) // Hide loading indicator
    }
  }

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleChangeItemsPerPage = e => {
    const selectedValue = parseInt(e.target.value)
    setItemsPerPage(selectedValue)
    setCurrentPage(1) // Reset to the first page when changing items per page
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handleApprovalPreviousPage = itemId => {
    if (activeItemId === null) {
      navigate("/approval/all")
    } else {
      setActiveItemId(null)
    }
  }

  const handleButtonClick = itemId => {
    setActiveItemId(itemId)
    localStorage.setItem("invoice", JSON.stringify(itemId))
  }

  const handleToggleRow = id => {
    setSelectedIds(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]))
  }

  const handleToggleAll = eligibleIds => {
    setSelectedIds(prev => {
      const allSelected = eligibleIds.length > 0 && eligibleIds.every(id => prev.includes(id))
      return allSelected
        ? prev.filter(id => !eligibleIds.includes(id))
        : [...new Set([...prev, ...eligibleIds])]
    })
  }

  const signSignables = async (objectIds, approved, commentText) => {
    try {
      if (!objectIds || objectIds.length === 0) {
        throw new Error("No invoice selected.")
      }

      setError("")
      setApprovalMessage("")

      const body = { object_ids: objectIds, approved }
      if (commentText !== undefined) {
        body.comment = commentText
      }

      await axiosInstance.post("/approvals/v1/sign/invoice", body)

      setApprovalMessage(
        `${objectIds.length > 1 ? "Invoices" : "Invoice"} ${approved ? "Approved" : "Declined"} Successfully`,
      )
      setConfirmationModalShow(true)
    } catch (error) {
      console.log(error, "Error during the invoice signing process.")

      if (error?.response?.status === 401) {
        setsessionExpired(true)
      } else {
        const errorMessage = error.response.data.message || "Error with the request"
        setError(errorMessage)
        setApprovalMessage(errorMessage)
      }
      setConfirmationModalShow(true)
    } finally {
      setLoading(false)
    }
  }

  const handleParentModalShow = action => {
    setAction(action)
    setBulkAction(false)
    setModalState(true)
  }

  const handleBulkApprove = () => {
    setAction("approve")
    setBulkAction(true)
    setModalState(true)
  }

  const handleModalConfirm = async () => {
    setModalState(false)
    setLoading(true)
    if (bulkAction) {
      await signSignables(selectedIds, action === "approve", comment)
    } else {
      await signSignables([invoice.id], action === "approve", comment)
    }
  }

  const handleCloseConfirmationModal = () => {
    setConfirmationModalShow(false)
    if (error) {
      setError("")
      setApprovalMessage("")
      return
    }
    if (action === "approve") {
      navigate(`/approval/all?${buildRouteQuery({ page: 1, status: "pending" })}`)
    } else {
      navigate(`/approval/all?${buildRouteQuery({ page: 1, status: "declined" })}`)
    }
  }

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages)
    }
  }, [currentPage, totalPages])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const pageParam = params.get("page")
    const pageSizeParam = params.get("page_size")

    const newPage = pageParam ? Number(pageParam) : 1
    const newPageSize = pageSizeParam ? Number(pageSizeParam) : 10

    setPage(newPage)
    setSize(newPageSize)

    getSignables(newPage, newPageSize)
  }, [location.search])

  return (
    <>
      {loading && <Loader />}
      {sessionExpired ? (
        <SessionExpired />
      ) : (
        <div>
          <Header />

          <div className="flex flex-col md:flex-row">
            {/* Sidebar for larger screens */}
            <div className="hidden md:block">
              <Sidenav />
            </div>

            <div className="content md:w-[80%] w-full md:ml-[20%] lg:w-[86%] lg:ml-[14%] p-3 mt-[70px]">
              <PageTitleBar
                title={"Pending Invoices"}
                onPrevPage={handleApprovalPreviousPage}
                itemId={activeItemId}
              />

              {activeItemId ? (
                <div className="flex flex-col md:flex-row gap-3 overflow-x-auto">
                  {/* Invoice Container */}
                  <div
                    className="w-full md:w-[70%] bg-white flex flex-col py-4 overflow-auto"
                    id="pdf"
                  >
                    <Invoice receipt={invoice} />
                  </div>

                  {/* Approval Status and Form */}
                  <div className="w-full md:w-[30%] rounded-lg">
                    <p className="approval-card-title text-center py-2 rounded-t-md bg-gray-100 font-semibold">
                      Status: Awaiting Payment Approval
                    </p>
                    <div className="card p-4 space-y-3">
                      <FormGroup>
                        <FormLabel className="text-lg">Role</FormLabel>
                        <FormControl
                          className="pl-2 bg-gray-50 text-sm py-2"
                          placeholder="Role"
                          value={formatText(invoice.workflow.pending_approval_from)}
                          readOnly
                        />
                        <FormControl
                          className="mt-3 pl-2 bg-gray-50 text-sm py-2"
                          placeholder="Name"
                          value={name}
                        />
                        <FormLabel className="mt-3 flex items-center gap-2">
                          Comments
                          <div className="group relative">
                            <Info size={16} className="text-gray-500 cursor-help" />
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap z-10">
                              Comments entered here will reflect in the header text in ByD
                            </div>
                          </div>
                        </FormLabel>
                        <FormControl
                          as="textarea"
                          rows={4}
                          placeholder="Comments"
                          className="bg-gray-50 text-sm py-2 resize-none"
                          onChange={e => {
                            if (e.target.value.length <= 40) {
                              setComment(e.target.value)
                            }
                          }}
                          value={comment}
                          maxLength={40}
                        />
                        <div className="text-xs text-gray-500 mt-1 mb-2.5">
                          {comment.length}/40 characters
                        </div>
                      </FormGroup>

                      {/* Approval/Decline Buttons */}
                      <div className="flex justify-between mx-4 my-2 space-x-3">
                        <button
                          className="flex-1 flex items-center justify-center gap-1 px-3 py-2 text-white bg-green-600 rounded hover:bg-green-700 transition"
                          onClick={() => {
                            if (approvalCommentRequired && comment === "") {
                              setHoveredAction("approve")
                              setShowMessage(true)
                            } else {
                              handleParentModalShow("approve")
                            }
                          }}
                          onMouseEnter={() => {
                            if (approvalCommentRequired && comment === "") {
                              setHoveredAction("approve")
                              setShowMessage(true)
                            }
                          }}
                          onMouseLeave={() => {
                            setHoveredAction(null)
                            setShowMessage(false)
                          }}
                        >
                          <ThumbsDown className="text-lg" />
                          <span>Approve</span>
                        </button>

                        <button
                          className={`flex-1 flex items-center justify-center gap-1 px-3 py-2 text-white bg-red-500 rounded hover:bg-red-600 transition`}
                          onClick={() => {
                            if (comment === "") {
                              setHoveredAction("decline")
                              setShowMessage(true)
                            } else {
                              handleParentModalShow("decline")
                            }
                          }}
                          onMouseEnter={() => {
                            if (comment === "") {
                              setHoveredAction("decline")
                              setShowMessage(true)
                            }
                          }}
                          onMouseLeave={() => {
                            setHoveredAction(null)
                            setShowMessage(false)
                          }}
                        >
                          <ThumbsUp className="text-lg" />
                          <span>Decline</span>
                        </button>
                      </div>

                      {showMessage && comment === "" && (
                        <p className="text-red-600 text-sm mt-2">
                          Comment is required to {hoveredAction} this invoice
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="w-full">
                  {!isAccountsPayable && selectedIds.length > 0 && (
                    <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-md px-4 py-2 mb-3">
                      <span className="text-sm text-blue-900">
                        {selectedIds.length} invoice{selectedIds.length > 1 ? "s" : ""} selected
                      </span>
                      <div className="flex gap-2">
                        <button
                          type="button"
                          className="px-3 py-1.5 text-sm text-white bg-green-600 rounded hover:bg-green-700"
                          onClick={handleBulkApprove}
                        >
                          Approve Selected
                        </button>
                      </div>
                    </div>
                  )}
                  <TableCommponnent
                    data={currentData}
                    recent_invoice={false}
                    currentPage={currentPage}
                    handleChangeItemsPerPage={handleChangeItemsPerPage}
                    itemsPerPage={itemsPerPage}
                    handlePrevPage={handlePrevPage}
                    handleNextPage={handleNextPage}
                    totalPages={totalPages}
                    onButtonClick={handleButtonClick}
                    complete={true}
                    total={total}
                    count={count}
                    size={size}
                    page={page}
                    selectable={!isAccountsPayable}
                    selectedIds={selectedIds}
                    onToggleRow={handleToggleRow}
                    onToggleAll={handleToggleAll}
                  />
                </div>
              )}

              {/* Modal for Confirmation */}
              <Modal show={modalState} onHide={() => setModalState(false)} centered>
                <Modal.Body>
                  <div className="flex flex-col items-center justify-center">
                    <ApprovalModalImage />
                    <p>
                      Are you sure you want to {action}{" "}
                      {bulkAction ? `${selectedIds.length} invoices` : "this invoice"}?
                    </p>
                    <div className="flex gap-3 my-4">
                      <Button
                        style={{
                          backgroundColor: "#12AF2B",
                          borderRadius: "2px",
                          width: "120px",
                          borderColor: "#12AF2B",
                        }}
                        onClick={handleModalConfirm}
                      >
                        Yes
                      </Button>
                      <Button
                        style={{
                          backgroundColor: "#C00E19",
                          borderRadius: "2px",
                          width: "120px",
                          borderColor: "#C00E19",
                        }}
                        onClick={() => setModalState(false)}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              {error ? (
                <Error
                  message={approvalMessage}
                  show={confirmationModalShow}
                  handleShow={handleCloseConfirmationModal}
                />
              ) : (
                <Modal show={confirmationModalShow} onHide={handleCloseConfirmationModal} centered>
                  <Modal.Body>
                    <div className="flex flex-col items-center justify-center">
                      <img src={ApprovalStatusImage} alt="Approval Status" />
                      <p className="approval-status-message py-2">{approvalMessage}</p>
                      <Button
                        className="mb-4"
                        style={{
                          backgroundColor: "#12AF2B",
                          borderRadius: "2px",
                          width: "120px",
                        }}
                        onClick={handleCloseConfirmationModal}
                      >
                        Close
                      </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ApprovalPage
